import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class QuizzesService {
  fetch(quizId) {
    return securedAxiosInstance.get(`/quizzes/${quizId}`);
  }

  submitAttempt(quizId, { sellerId, storeId, answers }) {
    return securedAxiosInstance.post(`/quizzes/${quizId}/attempts`, toSnakeCase({ sellerId, storeId, answers }));
  }
}

export default new QuizzesService();
